import {
  ChatBubbleLeftIcon,
  InformationCircleIcon,
  WrenchScrewdriverIcon,
  TableCellsIcon,
} from '@heroicons/react/24/outline';
import { Box } from '@stereograph/teia-system-design/components/Box';
import { TabBar, TabBarItem, TabContainer, TabContent } from '../components/TabBar';
import { ChatTabView } from './chat/ChatTabView';
import { ConfigTabView } from './config/ConfigTabView';
import { InfoTabView } from './info/InfoTabView';
import { AliasTableTabView } from './alias-table/AliasTableTabView';

type Mode = 'chat' | 'config' | 'info' | 'alias-table';

export function ChatBotWidgetContent() {
  return (
    <Box
      sx={{
        width: 1,
        height: 1,
      }}
    >
      <TabContainer<Mode> defaultValue="chat">
        <TabBar>
          <TabBarItem<Mode> icon={ChatBubbleLeftIcon} value="chat" />
          <TabBarItem<Mode> icon={WrenchScrewdriverIcon} value="config" />
          <TabBarItem<Mode> icon={InformationCircleIcon} value="info" />
          <TabBarItem<Mode> icon={TableCellsIcon} value="alias-table" />
        </TabBar>
        <TabContent<Mode> value="chat">
          <ChatTabView />
        </TabContent>
        <TabContent<Mode> value="config">
          <ConfigTabView />
        </TabContent>
        <TabContent<Mode> value="info">
          <InfoTabView />
        </TabContent>
        <TabContent<Mode> value="alias-table">
          <AliasTableTabView />
        </TabContent>
      </TabContainer>
    </Box>
  );
}
